module.exports = __webpack_public_path__ + "static/media/icn_sort_alphabetic_active.3c212f31.svg";